import { Form, Radio } from "antd";
import styled from "styled-components";

export const StyledRadioBtn = styled(Radio.Button)`
    font-size: 13px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledFormItem = styled(Form.Item)`
    margin: 0;
    width: 100%;

    .ant-form-item-row {
        width: 100%;
    }
`;

export const StyledFormItemRadio = styled(StyledFormItem)`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const StyledRadioGroup = styled(Radio.Group)`
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
`;
